import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { comboBoxStyles } from "../../stylesGenerales/combobox";
import ReconocimientoModal from "./ReconocimientoModal";
import SubirCartaReconocimientoModal from "./SubirCartaReconocimientoModal";
const API = process.env.REACT_APP_API_URL;
const token = sessionStorage.getItem("token");

const ReconocimientoTable = () => {
    const [reconocimientos, setReconocimientos] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [openMenuId, setOpenMenuId] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [reconocimientoSeleccionado, setReconocimientoSeleccionado] =
        useState(null);
    const abrirModal = (reconocimiento) => {
        setReconocimientoSeleccionado(reconocimiento);
        setModalVisible(true);
    };
    const cerrarModal = () => {
        setModalVisible(false);
        setReconocimientoSeleccionado(null);
    };
    const toggleMenu = (id) => {
        setOpenMenuId(openMenuId === id ? null : id);
    };
    const [modalCartaVisible, setModalCartaVisible] = useState(false);
    const [reconocimientoCarta, setReconocimientoCarta] = useState(null);

    const abrirModalCarta = (reconocimiento) => {
        setReconocimientoCarta(reconocimiento);
        setModalCartaVisible(true);
    };

    const cerrarModalCarta = () => {
        setModalCartaVisible(false);
        setReconocimientoCarta(null);
    };

    const formatFecha = (fechaISO) => {
        if (!fechaISO) return "-";

        const fecha = new Date(fechaISO);
        const fechaLocal = new Date(
            fecha.getTime() +
            fecha.getTimezoneOffset() * 60000
        );

        const dia = fechaLocal
            .getDate()
            .toString()
            .padStart(2, "0");

        const mes = (fechaLocal.getMonth() + 1)
            .toString()
            .padStart(2, "0");

        const anio = fechaLocal.getFullYear();

        return `${dia}-${mes}-${anio}`;
    };

    const cargarReconocimientos = async () => {
        try {
            const response = await axios.get(
                `${API}/reconocimientos/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setReconocimientos(
                Array.isArray(response.data)
                    ? response.data
                    : response.data.results || []
            );
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        cargarReconocimientos();
    }, []);

    const reconocimientosFiltrados = useMemo(() => {
        const term = busqueda
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .trim();

        if (!term) {
            return [...reconocimientos].sort(
                (a, b) =>
                    new Date(b.createdat) -
                    new Date(a.createdat)
            );
        }

        return [...reconocimientos]
            .sort(
                (a, b) =>
                    new Date(b.createdat) -
                    new Date(a.createdat)
            )
            .filter((r) => {
                const empleado = (
                    r.nombre_empleado ||
                    r.idempleado_nombre ||
                    ""
                )
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "");

                const tipo = (r.tipocarta || "")
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "");

                const fecha = formatFecha(r.fecha)
                    .toLowerCase();

                const carta = r.iddocumento
                    ? "subida"
                    : "aun no subida";

                return (
                    empleado.includes(term) ||
                    tipo.includes(term) ||
                    fecha.includes(term) ||
                    carta.includes(term)
                );
            });
    }, [busqueda, reconocimientos]);

    return (
        <div
            style={{
                background: "#fff",
                borderRadius: "12px",
                padding: "20px 30px",
                boxShadow:
                    "0 4px 20px rgba(0,0,0,0.08)",
                position: "relative",
            }}
        >
            <div style={{ marginBottom: "15px" }}>
                <input
                    type="text"
                    placeholder="Buscar por trabajador, tipo, fecha o carta..."
                    value={busqueda}
                    onChange={(e) =>
                        setBusqueda(e.target.value)
                    }
                    style={{
                        width: "100%",
                        padding: "10px 14px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        fontSize: "15px",
                        boxSizing: "border-box",
                    }}
                />
            </div>

            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                }}
            >
                <thead>
                    <tr
                        style={{
                            background: "#023047",
                            color: "#fff",
                        }}
                    >
                        <th
                            style={{
                                padding: "10px",
                                textAlign: "left",
                            }}
                        >
                            Trabajador/a
                        </th>

                        <th
                            style={{
                                padding: "10px",
                                textAlign: "left",
                            }}
                        >
                            Tipo
                        </th>

                        <th
                            style={{
                                padding: "10px",
                                textAlign: "center",
                            }}
                        >
                            Fecha
                        </th>

                        <th
                            style={{
                                padding: "10px",
                                textAlign: "center",
                            }}
                        >
                            Carta
                        </th>

                        <th
                            style={{
                                padding: "10px",
                                textAlign: "center",
                            }}
                        >
                            Acciones
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {reconocimientosFiltrados.length > 0 ? (
                        reconocimientosFiltrados.map((r) => {
                            const tieneCarta =
                                Number(r.iddocumento) > 0;

                            return (
                                <tr
                                    key={
                                        r.idreconocimiento
                                    }
                                >
                                    <td
                                        style={{
                                            color: "#2563eb",
                                            fontWeight: 700,
                                            cursor: "pointer",
                                        }}
                                        onClick={() => abrirModal(r)}
                                    >
                                        {r.nombre_empleado || r.idempleado_nombre}
                                    </td>

                                    <td
                                        style={{
                                            padding: "10px",
                                            borderBottom:
                                                "1px solid #f0f0f0",
                                        }}
                                    >
                                        {r.tipocarta}
                                    </td>

                                    <td
                                        style={{
                                            padding: "10px",
                                            textAlign:
                                                "center",
                                            borderBottom:
                                                "1px solid #f0f0f0",
                                        }}
                                    >
                                        {formatFecha(
                                            r.fecha
                                        )}
                                    </td>

                                    <td
                                        style={{
                                            padding: "10px",
                                            textAlign:
                                                "center",
                                            borderBottom:
                                                "1px solid #f0f0f0",
                                            fontWeight: 600,
                                        }}
                                    >
                                        {tieneCarta ? (
                                            <span
                                                style={{
                                                    color:
                                                        "green",
                                                }}
                                            >
                                                Subida
                                            </span>
                                        ) : (
                                            <span
                                                style={{
                                                    color:
                                                        "red",
                                                }}
                                            >
                                                Aún no subida
                                            </span>
                                        )}
                                    </td>

                                    <td
                                        style={{
                                            padding: "10px",
                                            textAlign:
                                                "center",
                                        }}
                                    >
                                        <div
                                            style={
                                                comboBoxStyles.container
                                            }
                                        >
                                            <button
                                                style={
                                                    comboBoxStyles
                                                        .button
                                                        .base
                                                }
                                                onClick={() =>
                                                    toggleMenu(
                                                        r.idreconocimiento
                                                    )
                                                }
                                            >
                                                Opciones ▾
                                            </button>

                                            {openMenuId ===
                                                r.idreconocimiento && (
                                                    <div
                                                        style={{
                                                            ...comboBoxStyles
                                                                .menu
                                                                .container,
                                                            zIndex: 1000,
                                                            position:
                                                                "absolute",
                                                        }}
                                                    >
                                                        <div
                                                            style={
                                                                comboBoxStyles
                                                                    .menu
                                                                    .item
                                                                    .editar
                                                                    .base
                                                            }
                                                            onClick={() => {
                                                                setOpenMenuId(null);
                                                                abrirModalCarta(r);
                                                            }}
                                                        >
                                                            Subir carta firmada
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td
                                colSpan="5"
                                style={{
                                    textAlign: "center",
                                    padding: "20px",
                                }}
                            >
                                No se encontraron resultados para "
                                {busqueda}"
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            <ReconocimientoModal
                visible={modalVisible}
                onClose={cerrarModal}
                reconocimiento={reconocimientoSeleccionado}
            />

            <SubirCartaReconocimientoModal
                reconocimiento={reconocimientoCarta}
                onClose={cerrarModalCarta}
                onActualizado={cargarReconocimientos}
            />
        </div>
    );
};

export default ReconocimientoTable;